import {useEffect, useRef} from "react";

export function isNotchedPhoneFromApple() {
    let iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream
    let aspect = window.screen.width / window.screen.height
    return iPhone && aspect.toFixed(3) === "0.462";
}

/*
* Очень хорошая штука, работает как setInterval и даже пригоден для работы с хуками (WOW!).
* Очень удобно.
* */
export function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}
